import { Ban } from "lucide-react";
import type { UnsupportedReply } from "@/lib/api/assistant";

export function UnsupportedPanel({ unsupported }: { unsupported: UnsupportedReply }) {
  return (
    <div className="border border-slate-300 bg-slate-50 rounded-lg overflow-hidden">
      <div className="px-4 py-3 flex items-center gap-2 border-b border-slate-200">
        <Ban className="h-4 w-4 text-slate-600" />
        <span className="text-sm font-semibold text-slate-800">Unsupported question</span>
      </div>
      <div className="px-4 py-3 space-y-2 text-sm">
        <div>
          <div className="text-[11px] uppercase tracking-wide text-slate-500">
            Interpretation
          </div>
          <div className="text-slate-800 mt-0.5">{unsupported.interpretation}</div>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-wide text-slate-500">Reason</div>
          <div className="text-slate-800 mt-0.5">{unsupported.reason}</div>
        </div>
      </div>
    </div>
  );
}
